import api from "../../api/axios";

export const getAllServerUrls = async (params) => {
  let response = await api.get("/serverUrls", { params });
  return response.data;
};

export const addServerUrl = async (data) => {
  let response = await api.post("/serverUrls", data);
  return response.data;
};

export const updateServerUrl = async (id, data) => {
  let response = await api.put(`/serverUrls/${id}`, data);
  return response.data;
};
